/**
* DO NOT EDIT MANUALLY
* This is an auto-generated file.
* Any changes will be overwritten.
*/
import{o as e}from"algolia/client";import{buildProductUrl as t}from"algolia/algoliaAnalytics";import{USDFormatter as n}from"utils/USDFormatter";import{getTitleAttribute as r}from"algolia/hits";var i=({html:i,hit:a,components:o,showFitmentCheck:s})=>{let c=o.Highlight,l=e(),u=r(a);return i`
    <product-card
      class="card card--product h-full card--product-contained relative flex"
      data-hit-id="${a.objectID}"
      key="${`${a.objectID}-${l?.BegYear.toString()}-${l?.MakeName}-${l?.ModelName}-${l?.SubmodelName}-${l?.SubmodelName}`}"
    >
      <div class="card__media relative">
        <div class="image-blend">
          <a
            href="${t(a)}"
            aria-label="${a.PartNo}"
            class="media block relative js-prod-link"
            tabindex="-1"
          >
            <img
              src=${a.imageURL||`https://cdn.shopify.com/s/files/1/0814/6321/4354/files/Kanter-Auto-Shipment_Box.png?v=1736957471`}
              alt="Product photo of ${a.PartNo}, a ${a[u]}"
              class="img-fit card__main-image no-js-hidden"
            />
          </a>
        </div>
      </div>

      <div class="card__info-container">
        <div class="card__info-header">
          <div class="card__info">
            <div class="card__info-inner">
              <div class="card__part-header">
                <p class="card__vendor flex-wrap mb-2">
                  <span>
                    ${c({hit:a,attribute:`PartNo`})}
                  </span>

                  <span class="card__info__price individual"> | </span>

                  <span class="card__info__price individual"
                    >${!a.price||a.price===`0`||a.price===`0.00`?`Contact for pricing`:n.format(a.priceDecimal)}</span
                  >
                </p>

                ${s?i`<kanter-product-vehicle-fit-mini
                      begYear="${a.BegYear?.toString()}"
                      makeName="${a.MakeName}"
                      modelName="${a.ModelName}"
                      submodelName="${a.SubmodelName}"
                      is-universal-fitment="${a._tags?.includes(`Universal Fitment`)?``:null}"
                    ></kanter-product-vehicle-fit-mini>`:null}
              </div>

              <a
                href="${t(a)}"
                class="card-link clamp-2 mb-2 text-current card__title font-bold leading-none js-prod-link ${s?``:`card__title-sm`}"
              >
                ${c({hit:a,attribute:u})}
              </a>
            </div>
          </div>
        </div>
      </div>
    </product-card>
  `};export{i as ProductItem};